﻿import React, {Component} from "react";
import {connect} from "react-redux";
import WindowsStatus from "./windows-status";
import LinuxStatus from "./linux-status";
import ServerMessages from "./server-messages";
import Queues from "./queues";
import ListAppBar from "../core/list-app-bar";
import {IconButton, IconMenu, MenuItem, Tab, Tabs} from "material-ui";
import MoreVertIcon from "material-ui/svg-icons/navigation/more-vert";
import dashboardService from '../../services/dashboard-services';
import authService from '../../services/auth-services';

class Dashboard extends Component {
    constructor(props, context) {
        super(props, context);

        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
    }

    componentDidMount() {
        this.props.onCheckAuthorization();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isAuthorized) {
            this.props.onInitWebSocket();
        }
    }

    componentWillUnmount() {
        this.props.onUnload();
    }

    handleTabChange(value) {
        this.props.onTabChange(value);
    }

    handleLogout() {
        this.props.onLogout();
        this.props.onCloseWebSocket();
    }

    render() {
        const {tabIndex} = this.props;

        let serverMessages = "";
        let queues = "";

        if (tabIndex === 0) {
            serverMessages = <ServerMessages/>;
        } else if (tabIndex === 1) {
            queues = <Queues/>;
        }

        return (

            <div>
                <ListAppBar title="Dashboard" iconElementRight={
                    <IconMenu
                        targetOrigin={{horizontal: 'right', vertical: 'top'}}
                        anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                        iconButtonElement={
                            <IconButton><MoreVertIcon /></IconButton>
                        }>
                        <MenuItem primaryText="Sign out" onTouchTap={this.handleLogout}/>
                    </IconMenu>
                }/>
                <WindowsStatus />
                <LinuxStatus />

                <Tabs className="dashboard-messages-page" value={tabIndex} onChange={this.handleTabChange}>
                    <Tab label="Messages" value={0}>
                        {serverMessages}
                    </Tab>
                    <Tab label="Queues" value={1}>
                        {queues}
                    </Tab>

                    <Tab label="Clients" value={2}>

                    </Tab>

                </Tabs>

            </div>
        );
    }
}

const mapStateToProps = state => ({
    tabIndex: state.dashboard.tabIndex || 0,
    isAuthorized: state.dashboard.isAuthorized || false,
});
const mapDispatchToProps = dispatch => ({
    onTabChange: (index) =>
        dispatch({type: 'TAB_CHANGED', payload: index}),
    onCheckAuthorization: () =>
        dispatch({type: 'AUTHORIZATION_CHECKED', payload: dashboardService.DashboardServices.checkAuthorization()}),
    onInitWebSocket: () =>
        dispatch({type: 'INIT_WEB_SOCKET', payload: dashboardService.DashboardServices.initWebSockets()}),
    onLogout: () =>
        dispatch({type: 'LOGOUT', payload: authService.Auth.logout()}),
    onCloseWebSocket: () =>
        dispatch({type: 'CLOSE_WEB_SOCKET', payload: dashboardService.DashboardServices.closeWebSocket()}),
    onUnload: () =>
        dispatch({type: 'DASHBOARD_PAGE_UNLOADED'})
});

Dashboard = connect(mapStateToProps, mapDispatchToProps)(Dashboard);

export default Dashboard;